import {
    LIST_OFIJUS,
    LIST_OFIJUS_SUCCESS,
    LIST_OFIJUS_ERROR,
    ADD_OFIJUS,
    SAVE_OFIJUS,
    SAVE_OFIJUS_SUCCESS,
    SAVE_OFIJUS_ERROR,
    EDIT_OFIJUS,
    UPDATE_OFIJUS,
    UPDATE_OFIJUS_SUCCESS,
    UPDATE_OFIJUS_ERROR,
    DELETE_OFIJUS,
    DELETE_OFIJUS_SUCCESS,
    DELETE_OFIJUS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    ofijus: null,
    error: null,
    loading: false,
    ofijuSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_OFIJUS:
            return {
                ...state,
                loading: true
            }
        case LIST_OFIJUS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_OFIJUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                ofijus: action.payload
            }
        case SAVE_OFIJUS:
        case DELETE_OFIJUS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_OFIJUS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_OFIJUS_ERROR:
        case UPDATE_OFIJUS_ERROR:
        case DELETE_OFIJUS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_OFIJUS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                ofijus: [...state.ofijus, action.payload]
            }
        case ADD_OFIJUS:
            return {
                ...state,
                ofijuSelected: null,
                isEdit: false
            }
        case EDIT_OFIJUS:
            return {
                ...state,
                ofijuSelected: action.payload,
                isEdit: true
            }
        case UPDATE_OFIJUS_SUCCESS:
        case DELETE_OFIJUS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                ofijus: state.ofijus.map(ofiju => 
                    ofiju.id === action.payload.id ? ofiju = action.payload : ofiju
                ),
                ofijuSelected: null
            }
        // case DELETE_OFIJUS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         ofijus: state.ofijus.filter( ofiju => ofiju.id !== action.payload)
        //     }
        default:
            return state;
    }
}